import React, { Component } from 'react'
import {
    FormControl,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from '@mui/material'
import SelectList from '../../Elements/SelectList'
import DisplayItemLinkSortSettings from './DisplayItemLinkSortSettings'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DisplayItemLinkSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blocks: [],
            customDisplayPos: [],
            displayPos: [],
            views:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.views
                    ? this.props.item.settings.views
                    : [],
            block:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.block
                    ? this.props.item.settings.block
                    : null,
            sort:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.sort
                    ? this.props.item.settings.sort
                    : null,
            hide_add:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.hide_add === true
                    ? true
                    : false,
            show_multi_add:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.show_multi_add === true
                    ? true
                    : false,
            only_allow_add:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.only_allow_add === true
                    ? true
                    : false,
            clickable:
                this.props.item &&
                this.props.item.settings &&
                typeof this.props.item.settings.clickable === 'boolean'
                    ? this.props.item.settings.clickable
                    : true,
            show_email:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.show_email === true
                    ? true
                    : false,
            enable_small_view:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.enable_small_view === true
                    ? true
                    : false,
            show_brp:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.show_brp === true
                    ? true
                    : false,
            embedded_single_view:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.embedded_single_view === true
                    ? true
                    : false,
            show_embedded:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.show_embedded === true
                    ? true
                    : false,
            show_id: this.props.item?.settings?.show_id === true ? true : false,
            custom_view:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.custom_view
                    ? this.props.item.settings.custom_view
                    : null,
            data_refresh:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.data_refresh
                    ? this.props.item.settings.data_refresh
                    : null,
            row_input:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.row_input
                    ? this.props.item.settings.row_input
                    : null,
            limit_embedded_link:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.limit_embedded_link
                    ? this.props.item.settings.limit_embedded_link
                    : false,
            default_val_dos_query:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.default_val_dos_query
                    ? this.props.item.settings.default_val_dos_query
                    : false,
            passing_sidebar:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.passing_sidebar
                    ? this.props.item.settings.passing_sidebar
                    : false,
            context_filter: this.props.item?.settings?.context_filter
                ? this.props.item.settings.context_filter
                : null,
        }
        this.onChangeView = this.onChangeView.bind(this)
        this.extraSettings = this.extraSettings.bind(this)
        this.fetchDisplayPos = this.fetchDisplayPos.bind(this)
    }

    fetchDisplayPos() {
        const kedo = this.props.kedo
        let params = {
            params: { defDossier: this.props.item.def_dossier_id, limit: 500 },
        }
        kedo.api()
            .getCached(kedo.api().getDisplayPositionEndpoint(), params)
            .then((displayPos) =>
                kedo
                    .api()
                    .get(kedo.api().getDisplayCustomViewEndpoint(), params)
                    .then((displayPosCustom) =>
                        this.setState({
                            displayPos: [
                                ...displayPos.data.results,
                                ...displayPosCustom.data.results,
                            ],
                        })
                    )
            )

        //Check for child defDossier id, to get custom views
        if (
            this.props.item.def_dossier_link &&
            this.props.item.def_dossier_link.child_def_dossier_id
        ) {
            let linkParams = {
                params: {
                    defDossier:
                        this.props.item.def_dossier_link.child_def_dossier_id,
                    limit: 500,
                },
            }

            kedo.api()
                .get(kedo.api().getDisplayCustomViewEndpoint(), linkParams)
                .then((linkPos) => {
                    this.setState({
                        customDisplayPos: linkPos.data.results,
                    })
                })
        }
    }

    extraSettings() {
        const kedo = this.props.kedo

        return (
            <>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel className={'required'}>
                        {this.props.kedo.t('Select view for sidebar')}
                    </FormInputLabel>
                    <Select
                        displayEmpty
                        size="small"
                        native
                        value={this.state.passing_sidebar}
                        name={'passing_sidebar'}
                        disabled={this.props.disabled}
                        onChange={(e) => {
                            this.setState(
                                { passing_sidebar: e.target.value },
                                this.props.onChange(
                                    'passing_sidebar',
                                    e.target.value !== ''
                                        ? e.target.value
                                        : null
                                )
                            )
                        }}
                    >
                        <option value="">{kedo.t('Switched off')}</option>
                        <optgroup label={kedo.t('Available views')}>
                            {this.state.displayPos &&
                                this.state.displayPos.map((pos) => (
                                    <option
                                        key={pos.id}
                                        value={
                                            pos && pos.view_name
                                                ? pos.view_name
                                                : pos.id
                                        }
                                    >
                                        {pos && pos.view_name
                                            ? pos.view_name
                                            : kedo
                                                  .env()
                                                  .translateItem(
                                                      pos,
                                                      'displayposition',
                                                      true
                                                  )}
                                    </option>
                                ))}
                        </optgroup>
                    </Select>
                </FormControl>
            </>
        )
    }

    fetchBlock(id) {
        if (!id) {
            return
        }

        const api = this.props.kedo.api()
        api.get(api.getMyPageBlockEndpoint(id)).then((response) =>
            this.setState({ block_data: response.data })
        )
    }

    onChangeView(e) {
        let views = this.state.views
        views = views.filter((item) => item !== e.target.value)
        if (e.target.checked) {
            views.push(e.target.value)
        }
        this.setState({ views: views }, () =>
            this.props.onChange('views', views)
        )
    }

    fetchData() {
        const api = this.props.kedo.api()

        api.get(api.getMyPageBlockEndpoint(), {
            params: {
                defDossier:
                    this.props.item.def_dossier_link.child_def_dossier_id,
                type: 'dashboard',
                environment: this.props.kedo.env().getEnvironment().id,
            },
        }).then((response) => this.setState({ blocks: response.data.results }))
    }

    componentDidMount() {
        this.fetchData()
        this.fetchDisplayPos()
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    renderCheckbox = (name, label, useCallback = false) => (
        <FormControl fullWidth margin="normal">
            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        name={name}
                        checked={this.state[name] === true}
                        disabled={this.props.disabled}
                        onChange={(e) => {
                            const checked = e.target.checked

                            if (useCallback) {
                                this.setState({ [name]: checked }, () =>
                                    this.props.onChange(name, checked)
                                )
                            } else {
                                this.setState({ [name]: checked })
                                this.props.onChange(name, checked)
                            }
                        }}
                    />
                }
                label={this.props.kedo.t(label)}
                sx={{
                    mb: 0,
                    '& .MuiFormControlLabel-label': {
                        fontSize: '0.875rem',
                        color: 'text.primary',
                    },
                }}
            />
        </FormControl>
    )

    render() {
        const kedo = this.props.kedo
        const hasBrp = kedo
            .env()
            .getCurrentEnvironmentModules()
            .find((item) => item.module === 'brp')
            ? true
            : false

        return (
            <div>
                <h3>{kedo.t('Settings')}</h3>
                {this.renderCheckbox('clickable', 'Show as hyperlink')}
                {this.renderCheckbox('hide_add', 'Hide add button')}
                {this.renderCheckbox('show_multi_add', 'Show multi add button')}
                {this.renderCheckbox('only_allow_add', 'Only allow add')}
                {this.renderCheckbox('show_email', 'Show email button')}
                {this.renderCheckbox('enable_small_view', 'Enable small view')}

                {hasBrp && this.renderCheckbox('show_brp', 'Show brp', true)}

                {this.renderCheckbox('show_embedded', 'Show embedded', true)}
                {this.renderCheckbox(
                    'embedded_single_view',
                    'Embedded single view',
                    true
                )}
                {this.renderCheckbox('show_id', 'Show ID', true)}
                {this.renderCheckbox('data_refresh', 'Data refresh', true)}
                {this.renderCheckbox('row_input', 'Row header input', true)}
                {this.extraSettings()}
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Limit by embedded dossier link field')}
                    </FormInputLabel>
                    <SelectList
                        currentValue={this.state.limit_embedded_link}
                        onClear={() => {
                            this.setState({ limit_embedded_link: null })
                            this.props.onChange('limit_embedded_link', null)
                        }}
                        disableInit={true}
                        disabled={this.props.disabled}
                        searchName={'search'}
                        kedo={kedo}
                        urlParams={{
                            environment: kedo.env().getEnvironment().id,
                        }}
                        onDisplayName={(item) => {
                            return item.id + ': ' + item.name
                        }}
                        url={kedo.api().getDefDossierLinkEndpoint()}
                        onSelect={(item) => {
                            this.setState({ limit_embedded_link: item.id })
                            this.props.onChange('limit_embedded_link', item.id)
                        }}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Default values dossier query')}
                    </FormInputLabel>
                    <SelectList
                        detailUrl={`/dossierquery/${this.state.default_val_dos_query}`}
                        currentValue={this.state.default_val_dos_query}
                        onClear={() => {
                            this.setState({ default_val_dos_query: null })
                            this.props.onChange('default_val_dos_query', null)
                        }}
                        disableInit={true}
                        disabled={this.props.disabled}
                        searchName={'search'}
                        kedo={kedo}
                        urlParams={{
                            environment: kedo.env().getEnvironment().id,
                            defDossier:
                                this.props.item.def_dossier_link
                                    .child_def_dossier_id,
                        }}
                        onDisplayName={(item) => {
                            return (
                                item.id +
                                ': ' +
                                this.props.kedo
                                    .env()
                                    .translateItem(item, 'dossierquery')
                            )
                        }}
                        url={kedo.api().getDossierQueryEndpoint()}
                        onSelect={(item) => {
                            this.setState({ default_val_dos_query: item.id })
                            this.props.onChange(
                                'default_val_dos_query',
                                item.id
                            )
                        }}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Enable views')}</FormInputLabel>
                    {[
                        'calendar',
                        'gantt',
                        'kanban',
                        'list',
                        'timeline',
                        'hourregistration',
                    ].map((viewItem) => (
                        <FormControlLabel
                            key={viewItem}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={this.state.views.includes(
                                        viewItem
                                    )}
                                    onChange={this.onChangeView}
                                    name="views"
                                    value={viewItem}
                                    disabled={this.props.disabled}
                                />
                            }
                            label={kedo.t(this.capitalizeFirstLetter(viewItem))}
                            sx={{
                                mb: 0,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary',
                                },
                            }}
                        />
                    ))}
                </FormControl>
                {this.props.item.def_dossier_link.type_of_link ===
                    'embeddedList' && (
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Custom views')}
                        </FormInputLabel>
                        <Select
                            displayEmpty
                            size="small"
                            id={'custom_link_view'}
                            value={this.state.custom_view}
                            onChange={(e) => {
                                this.setState({ custom_view: e.target.value })
                                this.props.onChange(
                                    'custom_view',
                                    e.target.value
                                )
                            }}
                            disabled={this.props.disabled}
                        >
                            <MenuItem value={''}>
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            {this.state.customDisplayPos &&
                                this.state.customDisplayPos.map((pos) => (
                                    <MenuItem
                                        key={pos.id}
                                        value={
                                            pos && pos.view_name
                                                ? pos.view_name
                                                : pos.id
                                        }
                                    >
                                        {pos && pos.view_name
                                            ? pos.view_name
                                            : kedo
                                                  .env()
                                                  .translateItem(
                                                      pos,
                                                      'displayposition',
                                                      true
                                                  )}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                )}
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Block')}</FormInputLabel>
                    <Select
                        displayEmpty
                        size="small"
                        name={'block'}
                        onChange={(e) => {
                            this.setState({ block: e.target.value })
                            this.fetchBlock(e.target.value)
                            this.props.onChange('block', e.target.value)
                        }}
                        value={this.state.block}
                        disabled={this.props.disabled}
                    >
                        <MenuItem value={''}>
                            {kedo.t('Choose an option')}
                        </MenuItem>
                        {this.state.blocks.map((block) => (
                            <MenuItem key={block.id} value={block.id}>
                                {kedo.env().translateItem(block, 'mypageblock')}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <DisplayItemLinkSortSettings
                        defDossierId={
                            this.props.item.def_dossier_link
                                .child_def_dossier_id
                        }
                        sort={this.state.sort}
                        onChangeSort={(sortSettings) => {
                            this.setState({ sort: sortSettings })
                            this.props.onChange('sort', sortSettings)
                        }}
                        kedo={kedo}
                        disabled={this.props.disabled}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>Context filter</FormInputLabel>
                    <SelectList
                        detailUrl={`/contextfilter/${this.state.context_filter}`}
                        currentValue={this.state.context_filter}
                        disableInit={true}
                        disabled={this.props.disabled}
                        searchName={'search'}
                        kedo={kedo}
                        urlParams={{
                            environment: this.props.kedo.env().getEnvironment()
                                .id,
                            defDossier: this.props.defDossierId,
                        }}
                        onDisplayName={(item) => {
                            return item.id + ': ' + item.name
                        }}
                        url={kedo.api().getContextFilterEndpoint()}
                        addUrl={kedo.api().getContextFilterEndpoint()}
                        onSelect={(item) => {
                            this.setState({ context_filter: item.id }, () =>
                                this.props.onChange('context_filter', item.id)
                            )
                        }}
                    />
                </FormControl>
            </div>
        )
    }
}

export default DisplayItemLinkSettings
